import { MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import React, { useEffect, useState } from 'react'
import Api from '../../../services/Api';
import PeoplePicker from "../../formFields/PeoplePicker";
import { useSelector } from 'react-redux';


const TempAdmins = ({siteId}) => {

    const currentUser = useSelector(state => state.user.currentUser);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [users, setUsers] = useState([currentUser]);
    const [isSaving, setIsSaving] = useState(false);
    const [site, setSite] = useState({})


    useEffect(() => {
        getSite(siteId);
    }, []);

    const getSite = (siteId) => {
        Api.get(`/Site?id=${siteId}`)
        .then(res => res.data)
        .then(site => {
            setSite(site);
        });
    }

    const addAdmins = () => {
        setSuccess(false);
        setError(false);

        if (users.length > 0) {
            setIsSaving(true);

            Api.post('AdminUpdateSiteRequest', {
                id: siteId,
                tempAdminsUsers: users
            })
            .then(res => res.data)
            .then(post => {
                setSuccess(true);
                setIsSaving(false);
            }).catch((error) => {
                setError(true);
                setIsSaving(false);
            })
        }
    }

    const activeTempAdmins = site.tempAdmins ? site.tempAdmins.filter(x => x.isActive && !x.channel) : null;

    return (
        <div style={divContainer}>
            <div>Added users will be automatically removed from Site Collection Administrators after 72 hours.</div>
            <div style={divContainer}>
                <PeoplePicker
                    defaultUsers={users}
                    onSelectedUsers={setUsers}
                />
            </div>
            <div style={divContainer}>
            {   
                isSaving
                ? <Spinner size={SpinnerSize.medium} style={{ float: 'left' }} />
                : <PrimaryButton onClick={addAdmins}>Add</PrimaryButton>
            }
            </div>
            <div style={divContainer}>
                { success && <MessageBar messageBarType={MessageBarType.success}>Request sent successfully. Administrators will be added in a few minutes.</MessageBar> }
                { error && <MessageBar messageBarType={MessageBarType.error}>Error occured during sending request.</MessageBar> }
            </div>
            <div>
                <div style={{fontWeight: 'bold', paddingBottom: '3px'}}>Temporary Administrators:</div>
                <div>
                    {
                        activeTempAdmins !== null
                        ?
                            (activeTempAdmins.length 
                            ? activeTempAdmins.map(x => <div key={x.user.id} title={x.user.email}>{x.user.displayName}</div>)
                            : 'None')
                        : <div style={{float: 'left', padding: '10px 0px 25px'}}><Spinner size={SpinnerSize.small} /></div>
                    }
                </div>
            </div>
        </div>
    );
}

const divContainer = {
    padding: '10px 0'
}


export default TempAdmins




// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/TempAdmins.js